'use client'

import React from 'react'
import LuggageIcon from '@mui/icons-material/Luggage'
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal'
import RestaurantIcon from '@mui/icons-material/Restaurant'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import EventBusyIcon from '@mui/icons-material/EventBusy'
import EventRepeatIcon from '@mui/icons-material/EventRepeat'

const baseIconStyle = {
    color: 'black',
    height: 20,
    width: 20,
}

const baseIconProps = {
    fontSize: 'small' as const,
    sx: baseIconStyle,
}

export const baggageIcon = <LuggageIcon {...baseIconProps} />

export const cabinBaggageIcon = <BusinessCenterIcon {...baseIconProps} />

export const cancellation = <EventBusyIcon {...baseIconProps} />

export const dateChange = <EventRepeatIcon {...baseIconProps} />

export const seatSelection = <AirlineSeatReclineNormalIcon {...baseIconProps} />

export const meal = <RestaurantIcon {...baseIconProps} />

export const included = (
    <CheckIcon
        fontSize="small"
        sx={{ ...baseIconStyle, color: 'green', mt: 0.5, flexShrink: 0 }}
    />
)

export const excluded = (
    <CloseIcon
        fontSize="small"
        sx={{ ...baseIconStyle, color: 'red', flexShrink: 0, transition: 'all 0.2s' }}
    />
)